import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(() => ({
	attentionText: {
		color: "#ff0000"
	}
}))

export default useStyles
